module.exports = __webpack_public_path__ + "static/img/072_TO8_1699.5d49920.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/072_TO8_1699.jpg
// module id = EXuc
// module chunks = 0